import { render, staticRenderFns } from "./seckill-item.vue?vue&type=template&id=6d86acb8&scoped=true"
import script from "./seckill-item.vue?vue&type=script&lang=js"
export * from "./seckill-item.vue?vue&type=script&lang=js"
import style0 from "./seckill-item.vue?vue&type=style&index=0&id=6d86acb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86acb8",
  null
  
)

export default component.exports